/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import { axiosInstance } from '../axiosInstance'


export const createAssetLocationUser = param => {
    return axiosInstance.post(`/api/gcadmin/v1/asset-location-application/createUser`, param).then(res => res.data)
}
export const dropAssetLocationUser = param => {
    return axiosInstance.post(`/api/gcadmin/v1/asset-location-application/dropUser`, param).then(res => res.data)
}
export const grantAssetLocationUser = param => {
    return axiosInstance.post(`/api/gcadmin/v1/asset-location-application/grantUser`, param).then(res => res.data)
}
export const revokeAssetLocationUser = param => {
    return axiosInstance.post(`/api/gcadmin/v1/asset-location-application/revokeUser`, param).then(res => res.data)
}
export const getAssetLocationUsers = param => {
    return axiosInstance.post(`/api/gcadmin/v1/asset-location-application/users`, param).then(res => res.data)
}
export const getAssetLocationUserGrants = param => {
    return axiosInstance.post(`/api/gcadmin/v1/asset-location-application/userGrants`, param).then(res => res.data)
}